import moment from "moment";

import { Client } from "@/Common/Api/Client";
import { DSQClinicalDocument, DSQObservationReport, MyleDSQResultsResponse } from "@/Common/Api/Dsq/Dto/Responses/MyleDSQResultsResponse";
import { ImportPopupComponent } from "@/Common/Components/DSQ/ImportPopupComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { SpanControl } from "@/Common/Components/SpanControl";
import { MyleTable } from "@/Common/Components/Tables/MyleTable";
import { MyleTableColumn, MyleTableColumnOptions } from "@/Common/Components/Tables/MyleTableColumn";
import { DSQHelper, DsqImportModel } from "@/Common/Helpers/DSQHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import { MyleDSQDocumentRequestModel, MyleDSQLab, MyleDSQLabImgRequestModel } from "@/Common/Models/DSQ/MyleDSQLab";
import { MedicalSummaryMedicationDetailsSortColumn } from "@/Common/Models/Patient/PatientEnums";
import { SortDirection } from "@/Common/Models/UI/Enums";
import { ITableRenderOptions } from "@/Common/Models/UI/Tables/ITableRenderOptions";
import { MyleTableTarget } from "@/Common/Models/UI/Tables/MyleTableTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ButtonControl } from "../Buttons/ButtonControl";
import ButtonGroup from "../Buttons/ButtonGroup";

import img_loading from "@/Globals/_images/loading.gif";

interface IDSQLabsGridComponent {
    onCloseCallback: () => void;
    patientContactId: string;
}

class DSQLabsGridComponentState {
    public From: Date;
    public To: Date;
    public DSQLabsList: Immutable.List<MyleDSQLab>;
    public DSQLoadedClinicalDocuments: DSQClinicalDocument;
    public showRightSide: boolean;
    public isLoading: boolean;
    public componentId: string;
    public isAllLabsChecked: boolean;
    public showImportPopup: boolean;
    public importPopupMessage: string;
    public userAskedForCancellation: boolean;
    public errorAtIndex: number;
    public importedFilesCount: number;
}

class DSQLabsGridComponent extends React.Component<IDSQLabsGridComponent, DSQLabsGridComponentState> {
    private Helper: MyleHelper = new MyleHelper();
    private saveOptionKey: string = "DSQLabsGrid_";
    private componentId: string = "DSQ_LabPopup";

    public constructor(props: IDSQLabsGridComponent) {
        super(props);
        const initialState = new DSQLabsGridComponentState();

        initialState.From = null;
        initialState.To = null;
        initialState.DSQLabsList = Immutable.List([]);
        initialState.isLoading = false;
        initialState.componentId = this.componentId;
        initialState.isAllLabsChecked = false;
        initialState.showImportPopup = false;
        initialState.importPopupMessage = "";
        initialState.userAskedForCancellation = false;
        initialState.errorAtIndex = -1;
        initialState.importedFilesCount = 0;

        this.state = initialState;
    }

    public componentDidMount(): void {
        window.setTimeout(() => {
            $(window).trigger("resize");
        }, 200);

        this.searchDSQLabs();
        overlayStore.showOverlay(this.componentId);
    }

    public componentWillUnmount(): void {
        overlayStore.hideOverlay(this.componentId);
    }

    public render(): JSX.Element {
        const s = this.state;
        const columnsOptions = this.Helper.loadTableColumnOptionsFromSettings(this.saveOptionKey, this.GetMyleTableColumnsDefaultOptions());
        const tableColumns = this.GetTableColumns(columnsOptions);
        const tableRenderOptions = this.LoadTableRenderOptions(columnsOptions);
        const leftSideWidth = this.state.DSQLoadedClinicalDocuments != null && this.state.showRightSide == true ? "40%" : "100%";
        const rightSideWidth = this.state.DSQLoadedClinicalDocuments != null && this.state.showRightSide == true ? "60%" : "100%";
        let isPrintDisabled = true;

        // Can print Labs that are checked and not imported
        if (s.DSQLabsList.filter(x => !!x.isChecked && !x.Model.IsImported).size > 0 || s.DSQLoadedClinicalDocuments != null)
            isPrintDisabled = false;

        return (
            <div id={this.state.componentId} className="dsq-activemed-popup popup-attachment-main popup-with-grid">
                <div className="dam-header p-header">
                    <div className="flex-container">
                        <div>
                            <h2>{cacheStore.GetString("ResultsLabel")}</h2>
                        </div>
                        <div className="pointer popup-attachment-header-right-btnClose" onClick={() => this.props.onCloseCallback()}>X</div>
                    </div>
                </div>

                {!!this.state.showImportPopup && (
                    <ImportPopupComponent
                        title={cacheStore.GetString("lblDSQLabResults")}
                        messageToDisplay={this.state.importPopupMessage}
                        cancelCallback={() => this.mutateState(s => {
                            s.showImportPopup = false;
                            s.userAskedForCancellation = true;
                            s.errorAtIndex = -1;
                        })}
                        closePopupCallback={() => this.mutateState(s => {
                            s.showImportPopup = false;
                            s.errorAtIndex = -1;
                        })}
                        isError={this.state.errorAtIndex > -1}
                        continueCallback={() => this.onContinueClick()}
                    />
                )}

                <div className="dam-main">
                    <div className="flex-container" style={{ "justifyContent": "flex-start" }}>

                        {/* Left Side */}
                        {this.LeftSideGrid(tableColumns, tableRenderOptions, leftSideWidth)}

                        {/* Separator */}
                        <div
                            className="flex-container aside-handle"
                            style={{ "justifyContent": "center", "flexDirection": "column", "display": "flex" }}
                            onClick={() => this.mutateState(s => s.showRightSide = !this.state.showRightSide)}
                        >
                            <div className="slide-menu-icon blue"><span /><span /><span /></div>
                        </div>

                        {/* Right Side */}
                        {this.state.DSQLoadedClinicalDocuments != null && this.state.showRightSide == true &&
                            this.RightSidepreview(rightSideWidth)
                        }
                    </div>
                </div>

                <div className="dam-footer">
                    <div className="row">
                        <div className="col-lg-9 col-md-9 col-sm-9">
                            <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                                <div>
                                    {this.state.isLoading && <img src={img_loading} alt="loading" />}
                                </div>
                                <div>
                                    <span style={{ fontStyle: "italic" }}>Ces données sont extraites du DOSSIER SANTÉ QUÉBEC (DSQ)</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-3 flex-display flex-end">
                            <ButtonGroup>
                                <ButtonControl
                                    className="btn btn-default"
                                    onClick={() => this.props.onCloseCallback()}
                                    label={cacheStore.GetString("CloseLabel")}
                                />
                                <ButtonControl
                                    className="btn btn-primary"
                                    disabled={isPrintDisabled}
                                    onClick={() => this.onLabPrint()}
                                    label={cacheStore.GetString("PrintLabel")}
                                />
                                <ButtonControl
                                    className="btn btn-primary"
                                    disabled={!this.state.DSQLabsList.some(x => x.isChecked && !x.Model.IsImported) && (this.state.DSQLoadedClinicalDocuments == null)}
                                    onClick={() => this.onImportClick()}
                                    label={cacheStore.GetString("ImportLabel")}
                                />
                            </ButtonGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public LeftSideGrid(tableColumns: Immutable.List<MyleTableColumn>, tableRenderOptions: ITableRenderOptions, LeftSideWidth: string): JSX.Element {
        let self = this;
        return (
            <div style={{ "width": LeftSideWidth }}>
                {/* HEAD */}
                <div style={{ "height": "90px" }}>
                    <div>
                        <div className="col-sm-1 col-md-1 col-lg-1 text-right">
                            <label className="label-date">{cacheStore.GetString("FromLabel")}</label>
                        </div>
                        <div className="col-sm-11 col-md-11 col-lg-11">
                            <DateSelector
                                id="dateDsq1"
                                date={this.state.From}
                                onChangeCallback={this.onFromChange.bind(this)}
                                dateFormat="yyyy-MM-dd"
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div style={{ "marginTop": "5px" }}>
                        <div className="col-sm-1 col-md-1 col-lg-1 text-right">
                            <label className="label-date">{cacheStore.GetString("ToLabel")}</label>
                        </div>
                        <div className="col-sm-11 col-md-11 col-lg-11">
                            <div className="custom-flex-container" style={{ marginTop: "5px", alignItems: "center" }}>
                                <DateSelector
                                    id="dateDsq2"
                                    date={this.state.To}
                                    onChangeCallback={this.onToChange.bind(this)}
                                    dateFormat="yyyy-MM-dd"
                                    disabled={false}
                                />
                                <div className="margin-sm-left">
                                    <ButtonControl
                                        className="btn btn-primary"
                                        disabled={this.state.isLoading}
                                        onClick={() => self.searchDSQLabs()}
                                        label={cacheStore.GetString("SearchLabel")}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fxheightpopup flex-container">
                    <MyleTable
                        TableRenderOptions={tableRenderOptions}
                        TableId="labMessage_message_table"
                        Columns={tableColumns}
                        DataSource={this.state.DSQLabsList}
                        ColumnsPreferencesChangedOperation={LocalOperations.Unassigned.Unassigned}
                        RowClickOperation={null}
                        RowClickFunction={item => this.rowClick(item)}
                        SaveOptionskeyTarget={this.saveOptionKey}
                        ColumnReorderTarget={MyleTableTarget.Myle_PatientCPP_MedicalItemMedicationReorderClick}
                        ColumnSortTarget={MyleTableTarget.Myle_PatientCPP_MedicalItemMedicationSortClick}
                    />
                </div>

            </div>

        );
    }

    public RightSidepreview(RightSideWidth: string): JSX.Element {
        const documentUrl = apiSettings.buildAppUrl(`api/pdf/fetch/${this.state.DSQLoadedClinicalDocuments.Document.HttpRelativePathNoPrint}`, { auth: true, hash: "toolbar=0&zoom=115" });

        return (
            <div className="flex-container" style={{ "width": RightSideWidth, "marginLeft": "20px", "flexDirection": "column" }}>
                {/* HEAD (REMOVED) */}

                {/* BODY */}
                <div style={{ "marginTop": "5px", "height": "100%" }}>
                    <iframe id="iframe-pdf-dsqlabs" src={documentUrl} height="100%" width="100%" />
                </div>
            </div>
        );
    }

    public PrintLabel(Label: string, Value: string): JSX.Element {
        return (
            <div className="flex-container">
                <div style={{ "width": "40%", "whiteSpace": "nowrap" }}>
                    <span style={{ "fontWeight": "bold" }}>{Label + " : "}</span>
                </div>
                <div style={{ "width": "60%", "whiteSpace": "nowrap" }}>
                    <span>{Value}</span>
                </div>
            </div>
        );
    }

    private onFromChange(value: Date): void {
        var s = new DSQLabsGridComponentState();
        s.From = value;
        this.setState(s);
    }

    private onToChange(value: Date): void {
        var s = new DSQLabsGridComponentState();
        s.To = value;
        this.setState(s);
    }

    private rowClick(item: MyleDSQLab): void {
        if (this.state.isLoading == true)
            return;

        var self = this;
        let client = new Client();

        var reportTypes = [];
        if (item.Model.Items != null) {
            item.Model.Items.forEach(x => {
                if (x.Requests != null) {
                    x.Requests.forEach(y => {
                        reportTypes.push(y.Type);
                    });
                }
            });
        }

        var requestData = {
            PatientContactId: self.props.patientContactId,
            SILID: item.Model.SLID,
            SILOID: item.Model.SILOID,
            ReportTypes: reportTypes,
            IsImaging: false
        };

        client.PostDSQ(
            ServerOperations.Server.DSQ_OpenLab,
            requestData,
            response => {
                let showRightSide = true;
                let s = new DSQLabsGridComponentState();
                s.isLoading = false;
                self.setState(s, () => {
                    if (response != null) {
                        if (response.Errors && response.Errors.length != 0) {
                            // DSQ errors (not Myle request errors)
                            showRightSide = false;
                            sessionStore.showPopup(response.Errors);
                        }

                        self.mutateState(s => {
                            s.DSQLoadedClinicalDocuments = response.ClinicalDocument;
                            s.showRightSide = showRightSide;
                        });
                    }
                });
            },
            () => self.mutateState(s => s.isLoading = false)
        );

        self.mutateState(s => s.isLoading = true);
    }

    private searchDSQLabs(): void {
        var self = this;
        let client = new Client();

        var requestData = {
            PatientContactId: self.props.patientContactId,
            StartDate: self.state.From,
            EndDate: self.state.To,
            IsImaging: false
        };

        client.PostDSQ(
            ServerOperations.Server.DSQ_GetLabs,
            requestData,
            (response: MyleDSQResultsResponse) => {
                let s = new DSQLabsGridComponentState();
                s.isLoading = false;
                self.setState(
                    s,
                    () => {
                        if (response != null) {
                            if (response.Errors && response.Errors.length != 0) {
                                // DSQ errors (not Myle request errors)
                                sessionStore.showPopup(response.Errors);
                            }
                            else {
                                let observations = response.Observations;

                                let messages = []
                                    .concat(response.Warnings)
                                    .filter(p => p);
                                if (observations == null || observations.length == 0)
                                    messages.push(cacheStore.GetString("NoDSQLabs"));

                                let DSQLabs = observations
                                    .filter(l => l.Items != null && l.Items.length > 0)
                                    .map(y => new MyleDSQLab(y));

                                DSQLabs.map(x => {
                                    if (!!x.Model.IsImported)
                                        x.isChecked = true;
                                });

                                self.mutateState(s => s.DSQLabsList = Immutable.List(DSQLabs));

                                if (messages.length > 0)
                                    sessionStore.showPopup(messages);
                            }
                        }
                    }
                );
            },
            () => self.mutateState(s => s.isLoading = false)
        );

        self.mutateState(s => s.isLoading = true);
    }

    private onImportClick(): void {
        let self = this;

        if (self.state.DSQLabsList == null)
            return;

        // Files that are checked are not already imported
        let filesToImport = self.state.DSQLabsList.toArray().filter(x => !!x.isChecked && !x.Model.IsImported).map(x => x.Model);

        // When no files are checked, import the one that is currently selected.
        if (filesToImport.length === 0 && self.state.DSQLoadedClinicalDocuments != null) {
            self.state.DSQLabsList.toArray()
                .filter(x => x.Model.DSQID === self.state.DSQLoadedClinicalDocuments.SILID)
                .map(x => filesToImport.push(x.Model));
        }

        if (filesToImport.length === 0)
            return;

        // Import single document
        if (filesToImport.length === 1) {
            this.mutateState(() => {
                // show popup with message to show that we started the imported job at index 0.
                self.mutateState(s => {
                    s.showImportPopup = true;
                    s.errorAtIndex = -1;
                    s.importPopupMessage = cacheStore.GetString("ImportingFileLabel") + ": " + filesToImport[0].Items[0].Title + "...";
                });
            });

            this.rawImport(
                filesToImport[0],
                response => {
                    if (self.handleImportErrors(response, filesToImport[0], 0) === true) return;

                    sessionStore.dispatch(LocalOperations.Documents.SearchSettings_OnRefreshClick);
                    let updatedLabsList = [].toImmutable();

                    if (self.state.errorAtIndex > -1) {
                        updatedLabsList = this.state.DSQLabsList.toArray().toImmutable();
                    }
                    else {
                        // Disable the checkbox for the file that has been successfully uploaded.
                        updatedLabsList = self.state.DSQLabsList.toArray().map(x => {
                            if (x.Model.DSQID === filesToImport[0].DSQID) {
                                x.Model.IsImported = true;
                                x.isChecked = true;
                                x.Model.HasNewItemInHistory = false;
                            }
                            return x;
                        }).toImmutable();

                        self.mutateState(s => {
                            s.DSQLabsList = updatedLabsList;
                            s.importPopupMessage = cacheStore.GetString("TheFileLabel") + " " + filesToImport[0].Items[0].Title + " " + cacheStore.GetString("ImportSuccessLabel");
                        });
                    }
                }
            );
        }
        else {
            // Import multiple documents
            this.mutateState(
                s => {
                    s.isLoading = true;
                    s.errorAtIndex = -1;
                },
                () => this.importSequence(filesToImport)
            );
        }
    }

    private importSequence(filesToImport: DSQObservationReport[], idx: number = 0): void {
        let self = this;
        let maxIndex = filesToImport.length - 1;
        let msg = self.state.importedFilesCount + " / " + filesToImport.length + " " + cacheStore.GetString("FilesImportedLabel") + ". " + cacheStore.GetString("ImportingFileLabel") + ": " + filesToImport[idx].Items[0].Title + "...";

        this.mutateState(
            () => {
                if (idx === 0) {
                    // show popup with message to show that we started the imported job at index 0.
                    self.mutateState(s => {
                        s.showImportPopup = true;
                        s.importPopupMessage = msg;
                        s.errorAtIndex = -1;
                    });
                }
                else {
                    // Started a new job, display a message saying that we're now working on this file...
                    self.mutateState(s => {
                        s.importPopupMessage = msg;
                        s.errorAtIndex = -1;
                    });
                }
            },
            () =>
                this.rawImport(filesToImport[idx], response => {
                    if (self.handleImportErrors(response, filesToImport[idx], idx) === true)
                        return;

                    sessionStore.dispatch(LocalOperations.Documents.SearchSettings_OnRefreshClick);

                    // Disable the checkbox for the file that has been successfully uploaded.
                    let updatedLabsList = self.state.DSQLabsList.toArray().map(x => {
                        if (x.Model.DSQID === filesToImport[idx].DSQID)
                            x.Model.IsImported = true;
                        return x;
                    }).toImmutable();

                    self.mutateState(
                        s => {
                            // current document imported.
                            // reset errors
                            s.DSQLabsList = updatedLabsList;
                            s.importPopupMessage = self.state.importedFilesCount + 1 + " / " + filesToImport.length + " " + cacheStore.GetString("FilesImportedLabel");
                            s.errorAtIndex = -1;
                            s.importedFilesCount = self.state.importedFilesCount + 1;
                        },
                        () => {
                            if (!!self.state.userAskedForCancellation) {
                                // Sequence not complete. Does not rollback.
                                self.mutateState(s => {
                                    s.importedFilesCount = 0;
                                    s.isLoading = false;
                                    s.showImportPopup = false;
                                    s.userAskedForCancellation = false;
                                });
                                return;
                            }

                            let nextDocIndex = ++idx;
                            if (nextDocIndex <= maxIndex && !self.state.userAskedForCancellation)
                                this.importSequence(filesToImport, nextDocIndex);
                            else {
                                // Import sequence complete.
                                self.mutateState(s => {
                                    s.isLoading = false;
                                    s.importPopupMessage = self.state.importedFilesCount + " / " + filesToImport.length + " " + cacheStore.GetString("FilesImportedLabel");
                                });
                                return;
                            }
                            return;
                        }
                    );
                })
        );
    }

    private rawImport(file: DSQObservationReport, handlerOverload: (response) => void = null): void {
        let self = this;

        var reportTypes = [];
        if (file.Items != null) {
            file.Items.forEach(x => {
                if (x.Requests != null) {
                    x.Requests.forEach(y => {
                        reportTypes.push(y.Type);
                    });
                }
            });
        }

        const req: DsqImportModel = {
            PatientContactId: this.props.patientContactId,
            SILID: file.SLID,
            SILOID: file.SILOID,
            ReportTypes: reportTypes,
            Category: file.Items[0].Categories
        };

        let hasError = DSQHelper.postImportDSQ(ServerOperations.Server.Myle_ImportDSQLabs, req, self.mutateState(s => s.isLoading = false), handlerOverload);

        if (!!hasError)
            return;
    }

    private handleImportErrors(response: any, file: DSQObservationReport, fileIndex: number): boolean {
        let self = this;
        let msg = "Failed at file " + file.Items[0].Title;

        if (response == null) {
            self.mutateState(s => {
                s.importPopupMessage = msg;
                s.errorAtIndex = fileIndex;
                s.isLoading = false;
            });

            return true;
        }

        if (response.Errors != null && response.Errors.length !== 0) {
            self.mutateState(s => {
                s.importPopupMessage = msg;
                s.errorAtIndex = fileIndex;
                s.isLoading = false;
            });

            return true;
        }

        return false;
    }

    // Click after there was an error
    private onContinueClick(): void {
        let self = this;
        let checkedLabs = self.state.DSQLabsList.toArray().filter(x => !!x.isChecked && !x.Model.IsImported).map(x => x.Model);
        let maxIndex = checkedLabs.length - 1;

        if (self.state.errorAtIndex + 1 > maxIndex) {
            self.mutateState(s => {
                s.showImportPopup = false;
                s.importedFilesCount = 0;
            });
            return;
        }

        self.importSequence(checkedLabs, self.state.errorAtIndex + 1);
    }

    private onLabPrint(): void {
        let self = this;
        let checkedFiles = self.state.DSQLabsList.filter(x => !!x.isChecked && !x.Model.IsImported); // checked but not imported

        // Merge then print said files
        if (checkedFiles.size > 0) {
            self.printMultipleDocuments(checkedFiles.toArray());
            return;
        }

        if (self.state.DSQLoadedClinicalDocuments == null || self.state.DSQLoadedClinicalDocuments.Document == null || self.state.DSQLoadedClinicalDocuments.Document.HttpRelativePath == null)
            return;

        PrintHelper.ShowPrintPreviewFileName(self.state.DSQLoadedClinicalDocuments.Document.HttpRelativePath);
    }

    private printMultipleDocuments(checkedFiles: MyleDSQLab[]): void {
        let self = this;

        // Merge then print checked files
        let labRequestModel = new MyleDSQLabImgRequestModel();
        labRequestModel.Documents = [];
        labRequestModel.IsImaging = false;

        checkedFiles.map(x => {
            let DSQDocument = new MyleDSQDocumentRequestModel();
            DSQDocument.ReportTypes = [];

            if (x.Model.Items != null) {
                x.Model.Items.forEach(x => {
                    if (x.Requests != null) {
                        x.Requests.forEach(y => {
                            DSQDocument.ReportTypes.push(y.Type);
                        });
                    }
                });
            }

            DSQDocument.SILID = x.Model.SLID;
            DSQDocument.SILOID = x.Model.SILOID;

            labRequestModel.Documents.push(DSQDocument);
        });

        let rq = {
            PatientContactId: self.props.patientContactId,
            LabsOrImagingToFetch: labRequestModel
        };

        // Get details for every file then merge to print
        Client.PostDSQ(
            ServerOperations.Server.Myle_PrintDSQDocument,
            rq,
            response => {
                self.mutateState(
                    s => s.isLoading = false,
                    () => {
                        if (response == null || response.FilePathToPrint == null)
                            return;

                        let messages = []
                            .concat(response.Errors)
                            .concat(response.Warnings)
                            .filter(p => p);

                        if (messages.length > 0) {
                            sessionStore.showPopup({
                                title: cacheStore.GetString("WarningLabel"),
                                content: messages
                            });
                        }

                        PrintHelper.ShowPrintPreviewFileName(response.FilePathToPrint);
                    }
                );
            }
        );
    }

    private GetTableColumns(columnOptions: Immutable.List<MyleTableColumnOptions>): Immutable.List<MyleTableColumn> {
        return MyleTableColumn.buildList<MyleDSQLab>(columnOptions, column => {
            switch (column.FieldName) {
                case "Checked":
                    return {
                        renderHeader: () => (
                            <div>
                                <CheckboxControl
                                    id="FilesAllCheckedPopup"
                                    checked={!!this.state.isAllLabsChecked}
                                    onChange={isChecked => this.mutateState(s => {
                                        s.DSQLabsList = this.state.DSQLabsList
                                            .toArray()
                                            .map(x => {
                                                if (!x.Model.IsImported)
                                                    x.isChecked = isChecked;
                                                return x;
                                            })
                                            .toImmutable();

                                        s.isAllLabsChecked = isChecked;
                                    })}
                                />
                            </div>
                        ),
                        renderCell: item => (
                            <div>
                                <CheckboxControl
                                    checked={!!item.isChecked}
                                    disabled={!!item.Model.IsImported}
                                    onChange={() => this.mutateState(s => {
                                        s.DSQLabsList = this.state.DSQLabsList.map(x => {
                                            if (x.Model.DSQID === item.Model.DSQID) x.isChecked = !x.isChecked;
                                            return x;
                                        }).toArray().toImmutable();
                                    })}
                                />
                            </div>
                        )
                    };

                case "PrescribedBy":
                    return {
                        renderCell: item => {
                            var Name = item.Model.PrescribedBy.LastName + ", " + item.Model.PrescribedBy.FirstName;
                            if (item.Model.PrescribedBy.LicenseNumber != null && item.Model.PrescribedBy.LicenseNumber != "")
                                Name = Name + " (" + item.Model.PrescribedBy.LicenseNumber + ")";

                            return <div><SpanControl IsRed={item.Model.IsAbnormal} text={Name} /></div>;
                        }
                    };

                case "Date":
                    return {
                        renderCell: item => {
                            var DateDisplay = "";
                            if (item.Model.EffectiveTime != null) {
                                DateDisplay = moment(item.Model.EffectiveTime).format("YYYY-MM-DD HH:mm");
                            }

                            return <div><SpanControl IsRed={item.Model.IsAbnormal} text={DateDisplay} /></div>;
                        }
                    };

                case "Title":
                    return {
                        renderCell: item => (
                            <div><SpanControl IsRed={item.Model.IsAbnormal} text={item.Model.Items[0].Title} /></div>
                        )
                    };

                case "Category":
                    return {
                        renderCell: item => (
                            <div><SpanControl IsRed={item.Model.IsAbnormal} text={item.Model.Items[0].Categories} /></div>
                        )
                    };

                case "Status":
                    return {
                        renderCell: item => (
                            <div><SpanControl IsRed={item.Model.IsAbnormal} text={item.Model.DSQStatus} /></div>
                        )
                    };

                case "Abnormal":
                    return {
                        renderCell: item => {
                            var statusDisplay = "N/A";
                            if (item.Model.IsAbnormal == true)
                                statusDisplay = "Anormal";

                            return <div><SpanControl IsRed={item.Model.IsAbnormal} text={statusDisplay} /></div>;
                        }
                    };
            }
        });
    }

    private GetMyleTableColumnsDefaultOptions(): MyleTableColumnOptions[] {
        var cols: MyleTableColumnOptions[] = [];

        var c_optMinus1 = new MyleTableColumnOptions();
        c_optMinus1.HeaderText = "";
        c_optMinus1.FieldName = "Checked";
        c_optMinus1.IsFixedInPlace = true;
        c_optMinus1.RowClickEnabled = false;
        c_optMinus1.WidthPercentageDefault = 5;

        var c_opt0 = new MyleTableColumnOptions();
        c_opt0.HeaderText = cacheStore.GetString("PrescribedByLabel");
        c_opt0.FieldName = "PrescribedBy";
        c_opt0.IsFixedInPlace = true;
        c_opt0.RowClickEnabled = true;
        c_opt0.WidthPercentageDefault = 25;

        var c_opt1 = new MyleTableColumnOptions();
        c_opt1.HeaderText = cacheStore.GetString("DateLabel");
        c_opt1.FieldName = "Date";
        c_opt1.RowClickEnabled = true;
        c_opt1.IsSortable = true;
        c_opt1.SortColumn = MedicalSummaryMedicationDetailsSortColumn.Medication;
        c_opt1.SortDirection = SortDirection.ASC;
        c_opt1.WidthPercentageDefault = 10;

        var c_opt2 = new MyleTableColumnOptions();
        c_opt2.HeaderText = cacheStore.GetString("TitleLabel");
        c_opt2.FieldName = "Title";
        c_opt2.RowClickEnabled = true;
        c_opt2.IsSortable = true;
        c_opt2.SortColumn = MedicalSummaryMedicationDetailsSortColumn.Beginning;
        c_opt2.SortDirection = SortDirection.ASC;
        c_opt2.WidthPercentageDefault = 20;

        var c_opt3 = new MyleTableColumnOptions();
        c_opt3.HeaderText = cacheStore.GetString("CategoryDLabel");
        c_opt3.FieldName = "Category";
        c_opt3.RowClickEnabled = true;
        c_opt3.IsSortable = true;
        c_opt3.SortColumn = MedicalSummaryMedicationDetailsSortColumn.Ended;
        c_opt3.SortDirection = SortDirection.ASC;
        c_opt3.WidthPercentageDefault = 30;

        var c_opt4 = new MyleTableColumnOptions();
        c_opt4.HeaderText = cacheStore.GetString("StatusDLabel");
        c_opt4.FieldName = "Status";
        c_opt4.RowClickEnabled = true;
        c_opt4.IsSortable = true;
        c_opt4.SortColumn = MedicalSummaryMedicationDetailsSortColumn.Dosage;
        c_opt4.SortDirection = SortDirection.ASC;
        c_opt4.WidthPercentageDefault = 10;

        var c_opt5 = new MyleTableColumnOptions();
        c_opt5.HeaderText = cacheStore.GetString("AbnormalsLabel");
        c_opt5.FieldName = "Abnormal";
        c_opt5.RowClickEnabled = true;
        c_opt5.IsSortable = true;
        c_opt5.SortColumn = MedicalSummaryMedicationDetailsSortColumn.Quantity;
        c_opt5.SortDirection = SortDirection.ASC;
        c_opt5.WidthPercentageDefault = 5;

        cols.push(c_optMinus1);
        cols.push(c_opt0);
        cols.push(c_opt1);
        cols.push(c_opt2);
        cols.push(c_opt3);
        cols.push(c_opt4);
        cols.push(c_opt5);

        return cols;
    }

    private LoadTableRenderOptions(columnOptions: Immutable.List<MyleTableColumnOptions>): ITableRenderOptions {
        var defaultTablePluginOptions = {
            MinColWidth: 60,
            MinTableWidth: 980,
            Cols: columnOptions.filter(x => x.IsHidden === false).map(i => i.WidthPercentage),
            FirstColumnNoDrag: false,
            LastColumnNoDrag: false,
            Autoresize: true,
            OnColumnWidthChange: null,
            HeightOffset: 65
        };

        return Immutable.fromJS(defaultTablePluginOptions);
    }

    private mutateState(mutation: (s: DSQLabsGridComponentState) => void, then: () => void = null): void {
        let s = new DSQLabsGridComponentState();
        mutation(s);
        this.setState(s, then);
    }
}

export { DSQLabsGridComponent };
